<template>
    <div class="content-wrapper">
      <section class="content-header">
        <h1>
          Review List
          <small>List of Review</small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
          <li class="active">Review</li>
        </ol>
      </section>
  
      <section class="content">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Filter Review</h3>
            <div class="box-tools pull-right">
              <button type="button"
                class="btn btn-box-tool"
                data-widget="collapse">
                <i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
  
          <div class="box-body" style="overflow: initial">
              <div class="left-form">
                <div class="form-group">
                  <label for="product_name">
                    Product Name
                  </label>
                  <v-select
                    name="favorite"
                    placeholder="Select favorite highlights"
                    v-model="product_name"
                    :options="listProducts">
                  </v-select>
                  <!-- <input type="text"
                    class="form-control"
                    id="product_name"
                    placeholder="Product Name"
                    v-model="params.product_name"
                    @keyup="onInput"> -->
                </div>
  
                <div class="form-group">
                  <label for="account_name" >
                    Account Name
                  </label>
                  <div>
                    <input type="text"
                    class="form-control"
                    id="name"
                    placeholder="Account Name"
                    v-model="params.name"
                    >
                  </div>
                </div>
  
                <div class="form-group">
                  <label for="type">
                    Email
                  </label>
                  <div>
                    <input type="text"
                    class="form-control"
                    id="email"
                    placeholder="Email"
                    v-model="params.email"
                    >
                  </div>
                </div>
                <div class="box-footer">
                  <button type="button" 
                    class="btn btn-success" 
                    @click="onExportCsv('normal')">
                    Export CSV
                  </button>
                </div>
              </div>
              <div class="right-form">
                <div class="row">
                    <label class="col-md-12" for="start_submit_date">
                    Submitted Date
                    </label>
                    <div class="form-group col-12 col-md-6">
                        <div>
                        <datepicker
                            id="start_submit_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :clear-button="true"
                            v-model="start_submit_date">
                        </datepicker>
                        </div>
                    </div>
      
                    <div class="form-group col-12 col-md-6">
                      <div>
                        <datepicker
                          id="end_submit_date"
                          wrapper-class="custom-vdp"
                          input-class="form-control"
                          :clear-button="true"
                          v-model="end_submit_date">
                        </datepicker>
                      </div>
                    </div>
                    <label class="col-md-12" for="start_approval_date">
                    Reviewed Date
                    </label>
                    <div class="form-group col-12 col-md-6">
                        <div>
                        <datepicker
                            id="start_approval_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :clear-button="true"
                            v-model="start_approval_date">
                        </datepicker>
                        </div>
                    </div>
        
                    <div class="form-group col-12 col-md-6">
                        <div>
                        <datepicker
                            id="end_approval_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :clear-button="true"
                            v-model="end_approval_date">
                        </datepicker>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label for="name">
                                Status
                            </label>

                            <select
                                id="status"
                                class="form-control"
                                placeholder="Select status"
                                v-model="params.approval_status"
                                value="null"
                                >
                                <option v-for="(status, index) in statuses" :key="index" :value="status.value">{{ status.title }}</option>
                            </select>
                        </div>
                    </div>
                </div>
              </div>
              <div>
                <button class="btn btn-success pull-right position-bottom" @click="pushState()">
                    Search
                </button>
                <button class="btn btn-secondary position-bot" @click="resetState()">
                  Reset
                </button>
              </div>
  
          </div>
        </div>
  
        <div class="box">
          <div class="box-header">
            <a class="btn btn-success pull-right"
              @click.prevent="add">
              Add New Review
            </a>
          </div>
  
          <div class="box-body">
            <table id="table" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style="min-width: 15rem">Submitted Date</th>
                  <th style="min-width: 30rem">Product Name</th>
                  <!-- <th class="text-center">Image</th> -->
                  <th style="min-width: 15rem">Account Name</th>
                  <th style="min-width: 15rem">Email</th>
                  <th style="min-width: 15rem">Type</th>
                  <th style="min-width: 15rem">Status</th>
                  <th style="min-width: 15rem">Reviewed Date</th>
                  <th style="min-width: 15rem">Action</th>
                </tr>
              </thead>
  
              <tbody>
                <tr v-if="isLoading">
                  <td class="text-center" colspan="7">
                    <strong>Loading...</strong>
                  </td>
                </tr>
                <tr v-if="!isLoading && error" key="empty">
                  <td class="text-center" colspan="7">
                    <strong>Data failed to load</strong>
                  </td>
                </tr>
                <tr v-if="(!isLoading && reviews.length < 1)">
                  <td class="text-center" colspan="7">
                    <strong>Result Not Found</strong>
                  </td>
                </tr>
                <tr v-for="review in reviews" :key="review.id">
                  <td>{{ parseTime(review.reviewed_at) }}</td>
                  <td>{{ review.product_name }}</td>
                  <!-- <td class="text-center">
                    <img
                      v-if="review.image && review.image != ''"
                      :src="parseImage(review.image, '_thumb')"
                      style="width: 64px;" />
                  </td> -->
                  <td>{{ review.name}}</td>
                  <td>{{ review.email }}</td>
                  <td>{{ review.type }}</td>
                  <td>{{ reviewType(review.approval_status) }}</td>
                  <td>{{ parseTime(review.approval_date) }}</td>
                  <td>
                    <a class="btn btn-primary btn-xs"
                      @click.prevent="edit(review.id)">
                      Preview
                    </a>
                    <!-- <a class="btn btn-danger btn-xs"
                      @click.prevent="remove(review)">
                      Delete
                    </a> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <div class="box-footer">
            <Pagination
              :pagination="pagination"
              @goto-page="changePage" />
          </div>
        </div>
      </section>
    </div>
  </template>
  <script>
  // import moment from 'moment';
  import Datepicker from 'vuejs-datepicker';
  import debounce from 'lodash/debounce';
  import Common from '@/mixins/Common';
  import Pagination from '@/components/modules/common/Pagination';
  import API_BASEURL from '../../../config';
  
  export default {
    name: 'ReviewIndex',
    mixins: [Common],
    components: {
      Pagination,
      Datepicker,
    },
    data() {
      return {
        params: {
          page: null,
          type: null,
          approval_status: null,
          name: null,
          export_csv: 0,
        },
        product_name: null,
        listProducts: [],
        start_submit_date: null,
        end_submit_date: null,
        start_approval_date: null,
        end_approval_date: null,
        reviews: [],
        isLoading: false,
        error: null,
        pagination: {},
        statuses: [
          { 
            title: 'All Status',
            value: null, 
          },
          {
            title: 'Waiting for Approval',
            value: 0,
          },
          {
            title: 'Approved',
            value: 1,
          },
          {
            title: 'Rejected',
            value: 2,
          },
        ],
        types: [
          { 
            title: 'All reviews Type',
            value: null, 
          },
          { 
            title: 'Default reviews',
            value: 'default_review', 
          },
          { 
            title: 'Top Hover reviews',
            value: 'top_review', 
          },
          { 
            title: 'Bottom Hover reviews',
            value: 'bottom_review', 
          },
  
        ],
      };
    },
    created() {
      this.init();
    },
    watch: {
      'params.page': {
        handler: (val) => {
          this.fetch(val);
        },
        deep: false,
      },
    },
    methods: {
      async init() {
        await this.setQuery();
        await this.fetch();
        await this.fetchListProducts();
        this.isInitial = false;
      },
      
      async onExportCsv() {
        let params = '';
        this.params.export_csv = 1;
        const paramsDate = {
          reviewed_at_from: this.startSubmitDate || '',
          reviewed_at_to: this.endSubmitDate || '',
          approval_date_from: this.startApprovalDate || '',
          approval_date_to: this.endApprovalDate || '',
        };
        const paramsName = {
          product_name: this.productName || '',
        };
        
        const totalRow = this.pagination.total;
        const queryParams = { ...this.params, ...paramsDate, ...paramsName };
        
      Object.keys(queryParams).forEach((key) => {
        params += `${key}=${queryParams[key] || ''}&`;
      });
      
      params = params.slice(0, -1);
      // if (this.params.status) {
        let url = '';
        url = `${API_BASEURL}/review/backoffice?${params}&perpage=${totalRow || ''}`;
        
        window.location = url;
        this.params.export_csv = 0;
    },
  
      setQuery() {
        return new Promise((resolve) => {
          this.params.name = this.$route.query.name || null;
          this.params.page = this.$route.query.page || 1;
          resolve();
        });
      },
  
      fetch(page = null) {
        this.isLoading = true;
        this.params.page = 0;
        if (page && typeof page !== 'object') this.params.page = page;
        // if (page) this.params.page = page || null;
        const paramsDate = {
          reviewed_at_from: this.parseTime(this.startSubmitDate, 'YYYY-MM-DD') || '',
          reviewed_at_to: this.parseTime(this.endSubmitDate, 'YYYY-MM-DD') || '',
          approval_date_from: this.parseTime(this.startApprovalDate, 'YYYY-MM-DD') || '',
          approval_date_to: this.parseTime(this.endApprovalDate, 'YYYY-MM-DD') || '',
        };
        const paramsName = {
          product_name: this.productName || '',
        };
        this.axios.get('/review/backoffice', { params: { ...this.params, ...paramsDate, ...paramsName } })
          .then((response) => {
            const { data, meta } = response.data;
  
            const isEmpty = (!data && 
                            (meta.pagination.current_page > 
                            meta.pagination.total_pages));
            this.reviews = (!isEmpty) ? data : [];
            this.pagination = (!isEmpty) ? meta.pagination : {};
            // this.setPushState();
          })
          .catch((error) => {
            console.log('Fetch error', error);
  
            if (error.response) {
              this.error = error.response.data.errors;
            }
  
            if (error) {
              this.$swal({
                title: 'Failed!',
                text: 'Failed to fetch Data', 
                type: 'warning',
                timer: 3000,
              });
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      },

      async fetchListProducts() {
        try {
          const response = await this.axios.get('/products-only');
          const products = response.data.data;
          if (products !== null) {
            products.forEach((item) => {
              this.listProducts.push({ 
                label: item.name, 
                value: item.name,
              });
            });
          }
        } catch (error) {
          console.log(error);
          if (error.response) {
            this.error.product = error.response.data.errors;
          }
        }
      },
      pushState() {
        this.fetch();
      },
      resetState() {
        this.params.page = null;
        this.params.approval_status = null;
        this.params.name = null;
        this.params.email = null;
        this.product_name = null;
        this.start_submit_date = null;
        this.start_approval_date = null;
        this.end_submit_date = null;
        this.end_approval_date = null;
        this.fetch();
      },
      setPushState() {
        const title = `reviews page ${this.params.page}`;
        const paramUrl = '/reviews';
        const parameters = this.generateQuery(this.params);
        const startSubmitParam = this.startSubmitDate ? `&reviewed_at_from=${this.startSubmitDate}` : '';
        const endSubmitParam = this.endSubmitDate ? `&reviewed_at_to=${this.endSubmitDate}` : '';
        const startApprovalParam = this.startApprovalDate ? `&approval_date_from=${this.startApprovalDate}` : '';
        const endApprovalParam = this.endApprovalDate ? `&approval_date_to=${this.endApprovalDate}` : '';
        window.history.pushState(title, null, `${paramUrl}${parameters}${startSubmitParam}${endSubmitParam}${startApprovalParam}${endApprovalParam}`);
      },
  
      generateQuery(params) {
        if (!params) return null;
  
        const query = Object.keys(params)
          .filter(key => (params[key]))
          .map(key => `${key}=${this.params[key]}`);
  
        return (query) ? `?${query.join('&')}` : null;
      },
  
      onInput: debounce(function debouncedInput() {
        this.params.page = null;
        this.fetch();
      }, 500),
  
      changePage(page) {
        this.fetch(page);
      },
  
      add() {
        this.$router.push({
          name: 'review-create',
        });
      },
  
      edit(id) {
        this.$router.push({
          name: 'review-approval',
          params: {
            id,
          },
        });
      },
  
      delete(review) {
        this.axios.delete(`/reviews/${review.id}`)
          .then(() => {
            this.fetch();
  
            this.$swal({
              title: 'Deleted',
              text: `${review.name} has been deleted.`,
              type: 'success',
              timer: 3000,
            });
          })
          .catch((error) => {
            if (error.response) {
              this.$swal({
                title: 'Failed',
                text: `Oppss! You can't delete "${review.name}" because this category still used by the product`,
                type: 'error',
                timer: 8000,
              });
            }
          });
      },
  
      remove(review) {
        this.$swal({
          title: 'Deleting review',
          text: `Are you sure you want to delete ${review.name}?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
        })
        .then((result) => {
          if (result.value) {
            this.delete(review);
          } else {
            this.$swal({
              title: 'Cancelled',
              type: 'info',
              timer: 3000,
            });
          }
  
          if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              type: 'info',
              timer: 3000,
            });
          }
        });
      },
    },
    computed: {
      startSubmitDate() {
        if (this.start_submit_date) {
          return this.parseTime(this.start_submit_date, 'YYYY-MM-DD hh:mm:ss');
        }
        return null;
      },
      endSubmitDate() {
        if (this.end_submit_date) {
          return this.parseTime(this.end_submit_date, 'YYYY-MM-DD hh:mm:ss');
        }
        return null;
      },
      startApprovalDate() {
        if (this.start_approval_date) {
          return this.parseTime(this.start_approval_date, 'YYYY-MM-DD hh:mm:ss');
        }
        return null;
      },
      endApprovalDate() {
        if (this.end_approval_date) {
          return this.parseTime(this.end_approval_date, 'YYYY-MM-DD hh:mm:ss');
        }
        return null;
      },
      productName() {
        if (this.product_name) {
          return this.product_name.value;
        }
        return null;
      },
      reviewType() {
        return (v) => {
          if (v === 0) {
            return 'Waiting for Approval';
          }
          if (v === 1) {
            return 'Approved';
          }
          if (v === 2) {
            return 'Rejected';
          }
          return null;
        };
      },
    },
  };
  </script>
  <style lang="scss" scoped>
    .left-form {
      width: 40%;
      float: left;
      margin-right: 50px;
    }
    .right-form {
      width: 50%;
      float: left;
    }
    .position-bot {
      position: absolute;
      bottom: 25px;
      right: 120px;
      width: 100px;
    }
    .position-bottom {
      position: absolute;
      bottom: 25px;
      right: 10px;
      width: 100px;
    }
  </style>
  
  


// WEBPACK FOOTER //
// src/components/modules/review/Index.vue